<template>
    <div>
        <!-- start page title -->
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Blogs</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            <li class="breadcrumb-item"><a href="/">Frontend Settings</a>
                            </li>
                            <li class="breadcrumb-item active">Blogs
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <!-- end page title -->

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4 class="card-title mb-0">
                            All Blogs
                        </h4>
                        <p class="card-title-desc">
                            <a :href="route('admin.cms.blogs.create')" class="btn btn-primary">Add Blog</a>
                        </p>
                    </div>
                    <div class="card-body">
                        <!-- Search Form -->
                        <div class="row mb-3">
                            <form class="form-inline" @submit.prevent="searchPosts">
                                <div class="col-md-8 col-sm-8 col-xs-6 col-lg-8">
                                    <div class="form-group mx-sm-3 mb-2">
                                        <input type="text" v-model="postSearchParams.title" class="form-control"
                                               id="title" placeholder="Post Title">
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-6 col-lg-4">
                                    <div class="pull-right">
                                        <button type="submit" class="btn btn-secondary mb-2">Search</button>
                                    </div>
                                </div>
                            </form>
                        </div> <!-- End Search Form-->
                        <vue-good-table
                            class="dataTable"
                            :pagination-options="paginationOptions"
                            :totalRows="totalRecords"
                            @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange"
                            styleClass="vgt-table"
                            :columns="columns"
                            :rows="post"
                        >
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                                </span>
                                <span v-else-if="props.column.label === 'Content'">
                                    {{
                                        props.row.content ? props.row.content.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 100) + '...' : ''
                                    }}
                                </span>
                                <span v-else-if="props.column.label === 'Status'">
                                    <span v-if="props.row.is_published === 0"
                                          class="badge badge-warning">
                                        not published
                                    </span>
                                    <span v-else class="badge badge-success">
                                        published
                                    </span>
                                </span>
                                <div class="form-group" v-else-if="props.column.label === 'Action'">
                                    <span class="dropdown">
									    <a id="btnSearchDrop2" data-toggle="dropdown" aria-haspopup="true"
                                           aria-expanded="false" class="dropdown-toggle dropdown-menu-right"><i
                                            class="fa fa-ellipsis-v"></i></a>
                                        <span aria-labelledby="btnSearchDrop2"
                                              class="dropdown-menu mt-1 dropdown-menu-right"
                                              x-placement="bottom-end"
                                              style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 19px, 0px);"
                                              x-out-of-boundaries="">

<!--                                               <a data-toggle="modal" data-target="#EditContactModal"-->
                                            <!--                                                  class="dropdown-item edit"><i class="feather icon-edit-2"></i>Edit</a>-->
                                             <a href="#"
                                                @click.prevent="changePostStatus( props.row.id, props.row.is_published )"
                                                class="dropdown-item"
                                                :class="{ 'text-success': ! props.row.is_published, 'text-warning':  props.row.is_published }"
                                             >
                                                <i class="feather icon-check"></i>
                                                {{ props.row.is_published ? 'Un-publish' : 'Publish' }}
                                            </a>

                                            <div class="dropdown-divider"></div>
                                            <a href="#" @click="showAlert( props.row.id)"
                                               class="dropdown-item text-danger">
                                                <i class="bx bx-trash-alt"></i> Delete
                                            </a>

                                        </span>
                                    </span>
                                </div>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
                <!-- end cardaa -->
            </div> <!-- end col -->
        </div> <!-- end row -->
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import axios from "axios";

export default {
    metaInfo: {title: 'Blogs'},
    name: 'BlogIndex',
    props: ['posts', 'preview_url'],
    layout: Layout,
    data: () => ({
        saving: false,
        post: [],
        postSearchParams: {
            title: null
        },
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Title', field: 'title', width: '15%'},
            {label: 'Content', field: 'content', sortable: false, width: '40%'},
            {label: 'Date Published', field: 'published_at', sortable: false},
            {label: 'Status', field: 'status', sortable: false},
            {label: 'Action', field: 'action', sortable: false},
        ],
    }),

    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        async paginatedData() {
            try {
                const type = this.type;
                let routeName = 'cms.blogs.paginate';
                if (type === 'research') {
                    routeName = 'cms.research-insight.paginate';
                }

                let {data: {data: {posts}}} = await axios.post(route(routeName),
                    {...this.serverParams});

                this.totalRecords = posts.total;
                this.paginationOptions.perPage = posts.per_page;
                this.post = posts.data
            } catch (e) {
                console.log(e);
            }
        },
        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },

        async changePostStatus(postId, status) {
            try {
                await this.$inertia.patch(route('cms.blogs.changeStatus', postId), {
                    status: status,
                }, {
                    preserveScroll: true,
                    onSuccess: () => {
                        location.reload()
                    }
                });
            } catch (e) {
                console.log(e);
            }
        },
        showAlert(postId) {
            let vInstance = this;

            this.$swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    vInstance.deleteFaq(postId)
                }
            });
        },
        deleteFaq(id) {
            this.$inertia.delete(route('cms.blogs.destroy', id), {
                preserveScroll: true,
                onSuccess: () => {
                    location.reload()
                }
            });
        },
        previewOnFrontend(post) {
            let url = this.preview_url + '/admin-view/blog/' + post.slug;
            window.open(url, '_blank').focus()
        },
        async searchPosts() {
            try {
                let url = this.type === 'blog' ? route('cms.blogs.search') : route('cms.research-insight.search');

                this.postSearchParams = {...this.postSearchParams, ...this.serverParams}
                let {data: {data: {posts}}} = await axios.post(url,
                    {...this.postSearchParams});

                this.totalRecords = posts.total;
                this.paginationOptions.perPage = posts.per_page;
                this.post = posts.data
            } catch (e) {
                console.log(e);
            }
        }
    },
    mounted() {
        this.post = this.posts.data
        this.totalRecords = this.posts.total
    },
}
</script>

<style scoped>

</style>
